import { render, staticRenderFns } from "./grid-image.vue?vue&type=template&id=bbaef538"
import script from "./grid-image.vue?vue&type=script&lang=js"
export * from "./grid-image.vue?vue&type=script&lang=js"
import style0 from "./grid-image.vue?vue&type=style&index=0&id=bbaef538&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports